import { render } from "./consume.vue?vue&type=template&id=73a54dd0&scoped=true"
import script from "./consume.vue?vue&type=script&lang=js"
export * from "./consume.vue?vue&type=script&lang=js"

import "./consume.vue?vue&type=style&index=0&id=73a54dd0&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a54dd0"]])

export default __exports__